module.exports = __webpack_public_path__ + "media/images/icon_list/sns_movie_filled-57e5544bff9f8a5e98ad74978ce7945e.svg";